import { Currency, USCurrency } from 'components/ReusableComponents/FormattedPrice/index'

import styles from './Invoice.module.scss'

const InvoiceTaxRow = ({ children, tax, usd, locale, currencyCode }) => (
  <div className={styles.taxRow}>
    <div className={styles.taxRowDesc}>{children}</div>
    <div className={styles.taxRowSum}>
      {usd ? (
        <USCurrency withCode>{tax}</USCurrency>
      ) : (
        <Currency locale={locale} currencyCode={currencyCode} withCode>
          {tax}
        </Currency>
      )}
    </div>
  </div>
)

export default InvoiceTaxRow
